import Presentacion from './views/PresentacionView.vue'
import PresentacionListView from './views/PresentacionListView.vue'

export default [
  {
    path: '/presentaciones',
    name: 'presentaciones',
    component: PresentacionListView
  },
  {
    path: '/presentacion/:id',
    name: 'presentacion',
    component: Presentacion
  }
]
